import React, { SVGProps } from 'react';

export const DownloadIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    {...props}
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      d="M21.9 14.25c0 8.25-.9 9.15-9.9 9.15s-9.9-.9-9.9-9.15h1.8c0 7.214.15 7.35 8.1 7.35 7.95 0 8.1-.134 8.1-7.35h1.8Zm-9-1.95V1.8h-1.8v10.5L6.706 7.904 5.43 9.18 12 15.75l6.57-6.57-1.276-1.274L12.9 12.3Z"
    />
  </svg>
);
